import PRDS from 'components/pos/PosReaderDialogStatus.const';
import { firstOf } from 'utils/arrays/elements.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import isNotEnumVal from 'utils/predicates/enum/isNotEnumVal.util';
import isPositiveNumber from 'utils/predicates/number/isPositiveNumber.util';

export const isPosEnabledStrictly = (value) => true === value;
export const isPosDisabledStrictly = (value) => true !== value;
export const isPosEnabledLoosely = (value) => !!value;

export const isPosFlowOpen = (options) => {
  //  NOTE: make sure POS is used only if posFLow is exactly true, not truthy
  if (!isPosEnabledStrictly(options?.posFlow)) return false;

  // should not open the dialog if the cardAmount is 0 or invalid
  if (!isPositiveNumber(options?.cardAmount)) return false;

  // check if the posStep is actually set and it isn't one of the closed states
  const posStep = options?.posStep;
  if (isNotEnumVal(PRDS, posStep)) return false;

  return PRDS.closed !== posStep && PRDS.cancel !== posStep;
};

export const isPosFlowFinished = (options) => {
  // NOTE: make sure POS is used only if posFLow is exactly true, no truthy
  if (isPosDisabledStrictly(options?.posFlow)) return true;

  return PRDS.success === options?.posStep;
};

const sumDeposits = (depositDataList) => {
  let total = 0;
  for (const { use_deposit: deposit } of depositDataList) total += deposit;

  return total;
};

const sumVouchers = (usedVouchers) => {
  if (!usedVouchers) return 0;

  let total = 0;
  for (const voucher of usedVouchers) if (voucher) total += voucher.used_amount;

  return total;
};

export const fromPropsToPaymentInfo = (props) => ({
  salonId: props?.salonId,
  appointmentId: firstOf(props?.appointments),
  clientId: firstOf(props?.data?.clients)?.id,
  chargeCard: props?.data?.onlineAmount > 0,
  voucherAmount: sumVouchers(props?.data?.vouchers_used),
  depositAmount: sumDeposits(props?.data?.depositListData),
  cardNumberEnd: fromAnyToTrimmed(props?.data?.active_card),
  cardAmount: props?.data?.cardAmount,
  cashAmount: props?.data?.partCash,
  otherAmount: props?.data?.otherAmount,
  onlineAmount: props?.data?.onlineAmount,
  total: props?.data?.total,
  items: [{ description: '', price: 0, quantity: 0 }],
});
